import { getOrderLineItemSurchargeValue, getOrderLineItemTotalPrice } from "../utils/OrderLineItemUtils";
import { IncludedSurcharge } from "../../../common/components/Product/ProductParams";
import { type OrderLineItemData } from "../modelsV2";
import { NetPrice as BaseNetPrice, TotalNetPrice as BaseTotalPrice } from "~/common/components/Price/v2/NetPrice";
import { useTranslation } from "react-i18next";
import { type QuoteLineItem } from "~/OrdersQuotes/QuoteListPage/api/fetchOrderDetails/dto";

interface Params {
  className?: string;
  data: OrderLineItemData | QuoteLineItem;
}

export const NetPrice = ({ data, className }: Params) => {
  const { t } = useTranslation();
  return (
    <BaseNetPrice
      price={data.netPrice}
      className={className}
      classes={{
        root: "scha__order-table__header",
        price: "scha__order-table__header__title scha__order-table__header__title--light",
      }}
      extraLabelsEnabled={false}
      zeroText={t("product.priceOnRequest")}
    />
  );
};

export const TotalPrice = ({ data, className }: Params) => {
  return (
    <BaseTotalPrice
      price={getOrderLineItemTotalPrice(data)}
      className={className}
      classes={{
        root: "d-flex flex-direction-column",
        price: "f-bold scha__order-table__header__title",
      }}
    />
  );
};

export const Surcharge = ({ data, className }: Params) => {
  const surcharge = getOrderLineItemSurchargeValue(data);
  if (surcharge.value === 0) {
    return null;
  }
  return <IncludedSurcharge className={className} value={surcharge} percent={data.netPrice.surcharge} />;
};

export const OrderLineItemElements = {
  NetPrice,
  TotalPrice,
  Surcharge,
};
